module.exports = __webpack_public_path__ + "static/media/no-attached-services.c94d3724.svg";